import { type CountryCode } from 'libphonenumber-js';

/**
 * Maps language codes to appropriate country codes for phone number inputs
 * @param languageCode - The i18n language code
 * @returns The corresponding country code
 */
export const getCountryCodeFromLanguage = (
  languageCode: string
): CountryCode => {
  const languageToCountryMap: Record<string, CountryCode> = {
    tr: 'TR',
    en: 'GB',
    de: 'DE',
    ru: 'RU',
    es: 'ES',
    az: 'AZ',
    fr: 'FR',
    ja: 'JP',
    ko: 'KR',
  };

  return languageToCountryMap[languageCode] ?? 'TR';
};
